import { render, staticRenderFns } from "./ExerciseCreate.vue?vue&type=template&id=6067405c&"
import script from "./ExerciseCreate.vue?vue&type=script&lang=js&"
export * from "./ExerciseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports